module.exports = __webpack_public_path__ + "static/media/controlled-breathing@3x.9d6ff91c.png";